import { Box, Grid, makeStyles, Typography } from "@material-ui/core";
import { motion, useTransform, useViewportScroll } from "framer-motion";
import React from "react";
import { useWindowSize } from "../../../../hooks/windowSize";

interface FullWidthAnimationBlockProps {
  headerOne: String;
  headerTwo: String;
}

const useStyles = makeStyles((theme) => ({
  mainWrapperColCenter: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    height: "75vh",
    gap: "100px",
    scrollSnapAlign: "start",
    [theme.breakpoints.down("md")]: {
      height: "75vh",
    },
    [theme.breakpoints.down("sm")]: {
      height: "55vh",
    },
    [theme.breakpoints.down("xs")]: {
      height: "50vh",
    },
  },
  jumbo: {
    fontSize: "240px !important",
    lineHeight: "100px !important",
    letterSpacing: 0,
    whiteSpace: "nowrap",
    WebkitTextStroke: "2px #fa255e",
    color: "#ffffff00",
    [theme.breakpoints.down("xs")]: {
      fontSize: "180px !important",
      letterSpacing: 0,
      lineHeight: "20px !important",
    },
  },
}));

export const FullWidthAnimationBlock: React.FC<FullWidthAnimationBlockProps> = (
  props
) => {
  const { headerOne, headerTwo } = props;
  const classes = useStyles(props);
  const { scrollY } = useViewportScroll();
  const size = useWindowSize();

  const xLeft = useTransform(
    scrollY,
    [size.innerHeight * 0.5, size.innerHeight * 3],
    [-1100, 1000]
  );

  const xRight = useTransform(
    scrollY,
    [size.innerHeight * 0.5, size.innerHeight * 3],
    [1000, -1100]
  );

  return (
    <Grid item xs={12} md={12}>
      <Box className={classes.mainWrapperColCenter}>
        <motion.div style={{ x: xLeft }}>
          <Typography variant="h1" className={classes.jumbo}>
            {headerOne}
          </Typography>
        </motion.div>
        <motion.div style={{ x: xRight }}>
          <Typography variant="h1" className={classes.jumbo}>
            {headerTwo}
          </Typography>
        </motion.div>
      </Box>
    </Grid>
  );
};
